export const environment = {
  production: true,
  deployment: 'PROD',
  apiURL: "https://pgapi.playground.genpact.com", // End point of translate file in python
  languageApi: "https://api.cognitive.microsofttranslator.com/languages?api-version=3.0&scope=translation",
  coreaiURL: 'https://genpactindprod.service-now.com/',
  nodeEndpoint: 'https://pgapi.playground.genpact.com/nodejs/',
  googleTranslateApi: "https://gapi.playground.genpact.com",
  coreAIBotURL: 'https://corp-wap-gkoregenai-03-fucpfwf4caa3ggdu.a01.azurefd.net/',
  coreAIBotURL_old: 'https://genius-websdk.azurewebsites.net/',

  // new UI prod
  // msADAccessTokenURL: 'https://corp-wap-eus-prod-tas-genaipg-02-eqg2a4edekd0h6gr.eastus-01.azurewebsites.net/.auth/me',
  // msADRedirectAuthURL: `https://genpact-india.vmwareidentity.asia/acs/authorize?response_type=code&client_id=hjfne45657nhk978ghmfnd23324234@fdrym&redirect_uri=https%3A%2F%2Fcorp-wap-eus-prod-tas-genaipg-02-eqg2a4edekd0h6gr.eastus-01.azurewebsites.net%2F.auth%2Flogin%2Fvmware%2Fcallback&nonce=3c2c0c7f69f242cb8017d9182d57ce57_20240708111040&state=redir%3D%252F&scope=openid+profile+email`,


  podurl: 'https://gapi.playground.genpact.com',
  podcastsurl: 'https://gapi.playground.genpact.com/podcasts',

  oktaIssuer: 'https://genpact.okta-emea.com/oauth2/default/', // Replace with your Okta domain
  oktaClientId: '0oaex7ypt5WIzU3OY0i7', // Replace with your Okta Client ID
  oktaRedirectUri: 'https://scout.genpact.com/home', // Callback URL to match Okta's setup

  msADAccessTokenURL: 'https://corp-wap-eus-prod-tas-genaipg-01.azurewebsites.net/.auth/me',
  msADRedirectAuthURL: `https://genpact-india.vmwareidentity.asia/acs/authorize?response_type=code&client_id=GenAIPlaygroundProd2024&redirect_uri=https%3A%2F%2Fcorp-wap-eus-prod-tas-genaipg-01.azurewebsites.net%2F.auth%2Flogin%2Fvmware%2Fcallback&nonce=3c2c0c7f69f242cb8017d9182d57ce57_20240708111040&state=redir%3D%252F&scope=openid+profile+email`,
  
  msredirecturi: 'http://localhost:4200/ask-genpact',



};
